import { ContentLayout11Theme } from '@components/content/components/content-layout-11/enum';
import { ContentLayout11Style } from '@components/content/components/content-layout-11/model';

export const contentLayout11Style: { [key: string]: ContentLayout11Style } = {
  [ContentLayout11Theme.BLUE]: {
    backgroundColor: 'BLUE',
    textColor: 'WHITE',
    labelColor: 'GREY_ALPHA',
  },
  [ContentLayout11Theme.OPAL]: {
    backgroundColor: 'OPAL',
    textColor: 'BLACK',
    labelColor: 'GREY_LIGHT',
  },
};
